import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useAuthStore } from "../lib/authStore";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ssnLogo from "../images/ssn-logo.png";
import { useResponsive } from "../lib/useResponsive";


export default function LoginPage() {
  const { login } = useAuthStore();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { isMobile } = useResponsive();

  const handleCredential = async (credentialResponse: any) => {
    setError("");
    setLoading(true);
    try {
      await login(credentialResponse.credential);
      navigate("/dashboard");
    } catch (e: any) {
      setError(e.response?.data?.detail ?? "Access denied. You may not be on the investor list.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ""}>
      <div style={S.page}>
        <div style={{
          ...S.card,
          padding: isMobile ? "28px 20px" : "40px",
          maxWidth: isMobile ? "100%" : "420px",
          margin: isMobile ? "0 16px" : "0",
          borderRadius: isMobile ? "12px" : "16px",
        }}>
          <div style={S.logoRow}>
            <div style={S.topbarLogo}>
              <img src={ssnLogo} alt="SSN" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "8px" }} />
            </div>
            <div>
              <div style={S.logoName}>ShivSena Networks, LLC</div>
              <div style={S.logoSub}>PRIVATE EQUITY FUND</div>
            </div>
          </div>

          <h2 style={{ ...S.heading, fontSize: isMobile ? "22px" : "26px" }}>Investor Portal</h2>
          <p style={S.sub}>
            This is a private portal. Access is restricted to verified fund members only.
          </p>

          {error && <div style={S.error}>{error}</div>}

          <div style={S.btnWrap}>
            {loading ? (
              <div style={S.loadingMsg}>Connecting to your portfolio…</div>
            ) : (
              <GoogleLogin
                onSuccess={handleCredential}
                onError={() => setError("Google sign-in failed. Please try again.")}
                useOneTap
                theme="filled_black"
                size="large"
                text="signin_with"
              />
            )}
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}

const S: Record<string, React.CSSProperties> = {
  page: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: `linear-gradient(rgba(13, 22, 29, 0.75), rgba(13, 22, 29, 0.75)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=1920')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    fontFamily: "'Inter', sans-serif",
    margin: 0,
    padding: "20px 0",
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    padding: "40px",
    borderRadius: "16px",
    backgroundColor: "rgba(25, 30, 36, 0.45)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.07)",
    textAlign: "left",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4)",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "36px",
  },
  topbarLogo: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: "8px",
    flexShrink: 0,
  },
  logoName: {
    color: "#00bfa5",
    fontSize: "14px",
    fontWeight: 600,
    letterSpacing: "0.3px",
  },
  logoSub: {
    color: "rgba(255, 255, 255, 0.35)",
    fontSize: "10px",
    fontWeight: 500,
    letterSpacing: "1.5px",
    marginTop: "2px",
  },
  heading: {
    color: "#e2e8f0",
    fontSize: "26px",
    fontWeight: "normal",
    fontFamily: "'Georgia', serif",
    margin: "0 0 16px 0",
  },
  sub: {
    color: "rgba(255, 255, 255, 0.55)",
    fontSize: "13px",
    lineHeight: "1.6",
    margin: "0 0 28px 0",
  },
  error: {
    backgroundColor: "rgba(239, 68, 68, 0.15)",
    color: "#f87171",
    padding: "10px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    marginBottom: "20px",
    border: "1px solid rgba(239, 68, 68, 0.2)",
  },
  btnWrap: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginBottom: "24px",
  },
  loadingMsg: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "13px",
    padding: "10px",
  },
  hint: {
    color: "rgba(255, 255, 255, 0.25)",
    fontSize: "11px",
    lineHeight: "1.5",
    textAlign: "center",
    margin: 0,
    paddingTop: "12px",
    borderTop: "1px solid rgba(255, 255, 255, 0.05)",
  },
};
